{
  "schemaVersion": 1,
  "product": "Sentra CTEM",
  "version": "1.1.0",
  "channel": "stable",
  "entry": "1.1.0",
  "publishedAt": "2026-09-07",
  "cadence": {
    "intervalDays": 14,
    "weekday": "monday",
    "nextPlannedDate": "2026-09-21"
  },
  "entries": [
    {
      "date": "2026-09-07",
      "month": "2026.09",
      "precision": "day",
      "kind": "release",
      "status": "published",
      "id": "1.1.0",
      "version": "1.1.0"
    },
    {
      "date": "2026-08-24",
      "month": "2026.08",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "1.0.24",
      "version": "1.0.24"
    },
    {
      "date": "2026-07-31",
      "month": "2026.07",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "1.0.21",
      "version": "1.0.21"
    },
    {
      "date": "2026-06-29",
      "month": "2026.06",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "1.0.17",
      "version": "1.0.17"
    },
    {
      "date": "2026-05-25",
      "month": "2026.05",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "1.0.14",
      "version": "1.0.14"
    },
    {
      "date": "2026-04-20",
      "month": "2026.04",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "1.0.10",
      "version": "1.0.10"
    },
    {
      "date": "2026-03-30",
      "month": "2026.03",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "1.0.7",
      "version": "1.0.7"
    },
    {
      "date": "2026-02-23",
      "month": "2026.02",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "1.0.3",
      "version": "1.0.3"
    },
    {
      "date": "2026-02-09",
      "month": "2026.02",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "1.0.0",
      "version": "1.0.0"
    },
    {
      "date": "2026-01-29",
      "month": "2026.01",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.12.0",
      "version": "0.12.0"
    },
    {
      "date": "2025-12-29",
      "month": "2025.12",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.11.2",
      "version": "0.11.2"
    },
    {
      "date": "2025-12-19",
      "month": "2025.12",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.11.0",
      "version": "0.11.0"
    },
    {
      "date": "2025-12-15",
      "month": "2025.12",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.10.0",
      "version": "0.10.0"
    },
    {
      "date": "2025-10-20",
      "month": "2025.10",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.9.8",
      "version": "0.9.8"
    },
    {
      "date": "2025-09-22",
      "month": "2025.09",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.9.5",
      "version": "0.9.5"
    },
    {
      "date": "2025-08-11",
      "month": "2025.08",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.9.1",
      "version": "0.9.1"
    },
    {
      "date": "2025-06-27",
      "month": "2025.06",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.7.1",
      "version": "0.7.1"
    },
    {
      "date": "2025-03-10",
      "month": "2025.03",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.6.3",
      "version": "0.6.3"
    },
    {
      "date": "2024-12-30",
      "month": "2024.12",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.6.1",
      "version": "0.6.1"
    },
    {
      "date": "2024-09-30",
      "month": "2024.09",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.3.5",
      "version": "0.3.5"
    },
    {
      "date": "2024-08-19",
      "month": "2024.08",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.2.4",
      "version": "0.2.4"
    },
    {
      "date": "2024-06-10",
      "month": "2024.06",
      "precision": "day",
      "kind": "release",
      "status": "historical",
      "id": "0.1.4",
      "version": "0.1.4"
    }
  ],
  "majorOneDate": "2026-02-09",
  "aliases": {
    "0.1.0": "0.1.4",
    "0.1.1": "0.1.4",
    "0.1.2": "0.1.4",
    "0.1.3": "0.1.4",
    "0.2.0": "0.2.4",
    "0.2.1": "0.2.4",
    "0.2.2": "0.2.4",
    "0.2.3": "0.2.4",
    "0.3.0": "0.3.5",
    "0.3.1": "0.3.5",
    "0.3.2": "0.3.5",
    "0.3.3": "0.3.5",
    "0.3.4": "0.3.5",
    "0.4.0": "0.6.1",
    "0.4.1": "0.6.1",
    "0.5.0": "0.6.1",
    "0.5.1": "0.6.1",
    "0.5.2": "0.6.1",
    "0.5.3": "0.6.1",
    "0.6.0": "0.6.1",
    "0.6.2": "0.6.3",
    "0.6.4": "0.7.1",
    "0.6.5": "0.7.1",
    "0.6.6": "0.7.1",
    "0.6.7": "0.7.1",
    "0.6.8": "0.7.1",
    "0.6.9": "0.7.1",
    "0.7.2": "0.9.1",
    "0.8.0": "0.9.1",
    "0.8.1": "0.9.1",
    "0.9.2": "0.9.5",
    "0.9.3": "0.9.5",
    "0.9.4": "0.9.5",
    "0.9.6": "0.9.8",
    "0.9.7": "0.9.8",
    "0.9.9": "0.10.0",
    "0.9.10": "0.10.0",
    "0.9.11": "0.10.0",
    "0.11.3": "0.12.0",
    "0.11.4": "0.12.0",
    "1.0.1": "1.0.3",
    "1.0.2": "1.0.3",
    "1.0.4": "1.0.7",
    "1.0.5": "1.0.7",
    "1.0.6": "1.0.7",
    "1.0.8": "1.0.10",
    "1.0.9": "1.0.10",
    "1.0.11": "1.0.14",
    "1.0.12": "1.0.14",
    "1.0.13": "1.0.14",
    "1.0.15": "1.0.17",
    "1.0.16": "1.0.17",
    "1.0.18": "1.0.21",
    "1.0.19": "1.0.21",
    "1.0.20": "1.0.21",
    "1.0.22": "1.0.24",
    "1.0.23": "1.0.24"
  }
}
